import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Check, AlertTriangle, CalendarX2 } from "lucide-react";

export default function BookingCancel() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token");
  const [state, setState] = useState("confirm"); // confirm | done | error
  const [err, setErr] = useState("");
  const [info, setInfo] = useState(null);
  const [already, setAlready] = useState(false);

  async function submit() {
    if (!token) { setState("error"); setErr("Link non valido."); return; }
    try {
      const { data } = await api.post("/bookings/cancel-by-token", { token });
      setInfo(data.booking);
      setAlready(!!data.already);
      setState("done");
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Impossibile annullare la prenotazione.");
      setState("error");
    }
  }

  useEffect(() => { if (!token) { setState("error"); setErr("Token mancante nel link."); } }, [token]);

  return (
    <div className="max-w-md mx-auto px-4 md:px-8 py-16" data-testid="booking-cancel-page">
      <div className="card-soft p-8">
        {state === "confirm" && (
          <>
            <div className="h-12 w-12 rounded-full bg-zinc-100 flex items-center justify-center mb-4 dark:bg-zinc-800">
              <CalendarX2 className="h-6 w-6 text-zinc-700 dark:text-zinc-300" />
            </div>
            <h1 className="font-display text-2xl font-medium">Annullare la prenotazione?</h1>
            <p className="text-sm text-zinc-600 mt-2 dark:text-zinc-400">
              Cliccando sul pulsante annullerai l'appuntamento. Lo slot verrà liberato per altri clienti.
            </p>
            <div className="flex gap-2 mt-6">
              <button onClick={() => nav("/")} className="btn-secondary h-11 flex-1" data-testid="cancel-btn-no">Non annullare</button>
              <button onClick={submit} className="h-11 flex-1 px-5 rounded-full text-sm font-medium bg-red-600 text-white hover:bg-red-700" data-testid="cancel-btn-yes">Annulla prenotazione</button>
            </div>
          </>
        )}
        {state === "done" && (
          <>
            <div className="h-12 w-12 rounded-full bg-emerald-100 flex items-center justify-center mb-4 dark:bg-emerald-950/40">
              <Check className="h-6 w-6 text-emerald-700 dark:text-emerald-300" />
            </div>
            <h1 className="font-display text-2xl font-medium">{already ? "Era già annullata" : "Prenotazione annullata"}</h1>
            {info && (
              <p className="text-sm text-zinc-600 mt-2 dark:text-zinc-400">
                {info.service_name} · {new Date(info.start_at).toLocaleString("it-IT", { weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}
                {info.business_name ? ` · ${info.business_name}` : ""}
              </p>
            )}
            <button onClick={() => nav("/")} className="btn-accent h-11 mt-6" data-testid="cancel-done-home">Torna alla home</button>
          </>
        )}
        {state === "error" && (
          <>
            <div className="h-12 w-12 rounded-full bg-red-100 flex items-center justify-center mb-4 dark:bg-red-950/40">
              <AlertTriangle className="h-6 w-6 text-red-700 dark:text-red-300" />
            </div>
            <h1 className="font-display text-2xl font-medium">Non è stato possibile annullare</h1>
            <p className="text-sm text-zinc-600 mt-2 dark:text-zinc-400" data-testid="cancel-err-msg">{err}</p>
            <button onClick={() => nav("/")} className="btn-secondary h-11 mt-6">Torna alla home</button>
          </>
        )}
      </div>
    </div>
  );
}
